module.exports = " <div class=\"drawing-panel halftone container\"> <div class=\"drawing-canvas overlay tool-cursor-{{ state.tool }}\"> <canvas id=paintcanvas width=512 height=288></canvas> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrawingPanel.vue
// module id = 175
// module chunks = 2